import { Injectable, signal } from '@angular/core';

/** Lets other parts of the app ask the home dashboard to expand and scroll to a specific application service item. */
@Injectable({
  providedIn: 'root',
})
export class ApplicationServiceItemFocusService {
  private readonly focusedApplicationServiceItemId = signal<number | undefined>(undefined);

  readonly focusRequest = this.focusedApplicationServiceItemId.asReadonly();

  requestFocus(applicationServiceItemId: number) {
    this.focusedApplicationServiceItemId.set(applicationServiceItemId);
  }

  clearFocusRequest() {
    this.focusedApplicationServiceItemId.set(undefined);
  }
}
